export const MenuSeparator = () => <div className="mx-2 my-auto h-6 w-px bg-gray-200" />;
